<template>
  <div id="map" class="default">
    <div class="inner">
      <div class="paths">
        <map-marker color="#000000" name="Du är här" top="1260" left="1890" arrowPosition="down"></map-marker>
        <map-marker color="#d6101c" number="2" name="Frösunda" direction="Bussar söderut" distance="4 min" top="1220" left="1215" arrowPosition="left"></map-marker>
        <map-marker color="#d6101c" number="2" name="Frösunda" direction="Bussar norrut" distance="2 min" top="987" left="1520" arrowPosition="left"></map-marker>
        <map-marker color="#6b2f89" number="1" name="Frösunda port" distance="4 min" top="1030" left="1115" arrowPosition="left"></map-marker>
        <map-marker color="#5ba4bb" number="5" name="Solna station" distance="8 min" top="1790" left="1115" arrowPosition="left"></map-marker>
        <map-marker color="#85c830" number="2" name="Frösundavik" direction="Skyttelbuss Solna stn" distance="0 min" top="1320" left="1690" arrowPosition="right"></map-marker>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2160 1920" width="2160" height="1920" class="shadow">
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1999.34,1324.67C1999.34,1324.67 1999.82,1487.17 1990.83,1537.77C1980.41,1596.34 1953.98,1636.76 1948.04,1664.56C1944.72,1680.12 1942.02,1692.97 1954,1692C1982.19,1689.71 2063.9,1672.37 2063.9,1672.37"/>
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1412.14,1751.57C1349.81,1761.24 1280.73,1763.02 1219,1776C1182.29,1783.72 1128.05,1800.81 1081.5,1812.74C1037.6,1824 997.607,1834.27 974.875,1841.91C952.9,1849.3 945.39,1861.78 935.446,1874.84C923.894,1890.01 917.457,1900.33 908.685,1920"/>
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1540.16,1121.92C1519.5,1107.99 1500.17,1085.66 1495,1074C1488.5,1059.33 1483,1036.67 1477,1018"/>
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1989.5,1318.24C1989.5,1318.24 1932.75,1342.94 1917,1337C1899.33,1330.33 1876.67,1294.17 1861,1290C1846.86,1286.24 1834.49,1321.07 1823,1312C1798.5,1292.67 1724.38,1176.83 1711.12,1177.43C1651.51,1180.12 1664.85,1178.6 1629,1165.16C1608.42,1157.44 1594.2,1132.42 1578.39,1123.07C1566,1115.74 1549.18,1118.63 1540.18,1123.63C1531.95,1128.2 1534.38,1138.28 1525,1139C1479.17,1142.5 1403.89,1151.82 1338.06,1146.49C1293.62,1142.88 1185.96,1134.53 1117.51,1116.78C1076.04,1106.02 1051.61,1114.19 1018,1119C993.04,1122.57 1004.5,1170 987,1188C969.5,1206 925,1211.83 913,1227C902.237,1240.6 915,1279 915,1279"/>
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1166.12,1127.25C1166.12,1127.25 1155.67,1171 1153,1183C1151.84,1188.22 1150.17,1194.5 1152,1199C1153.83,1203.5 1161.99,1204.96 1164,1210C1167.67,1219.17 1170.67,1239.33 1174,1254"/>
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1948.04,1659.42C1931.51,1676.09 1912.14,1701.59 1894,1707C1870.01,1714.15 1832.34,1718.23 1780.9,1712.86C1754.21,1710.07 1741.22,1702.98 1714.99,1705.56C1672.66,1709.73 1525,1735 1525,1735"/>
          <path class="path path-bus-xxx" fill="none" stroke="#ffffff" stroke-width="5" d="M1911.14,682.58s-35.77-51.82-80.71-67.87-69.71-2.3-69.71-2.3-49.53,36.23-60.54,50.45-31.18,39.44-42.64,71.08" transform="translate(0,438)" />
        </svg>
      </div>
      <div class="bg"></div>
    </div>
  </div>
</template>

<script>
import MapMarker from './components/Map/MapMarker.vue'

export default {
  data () {
    return { }
  },
  components: {
    MapMarker
  }
}
</script>

<style lang="scss">
  @import 'style/app.scss';
  #map {
    color: white;
    padding: 0;
    width: 1080px;
    height: 1920px;
    overflow: hidden;
    position: absolute;

    .inner {
      width: 2160px;
      height: 1920px;
      position: absolute;
      top: 0;
      right: 0;
    }

    .bg {
      display: block;
      width: 2160px;
      height: 1920px;
      background-image: url(./assets/map3.jpg);
      background-repeat: no-repeat;
      background-position-x: 1080px;
    }

    .map-marker {
      z-index: 2;
    }

    .paths {
      position: absolute;
      top: -438px;
      z-index: 1;
    }

    .shadow {
      filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
    }

    .path-bus-xxx {
      stroke-dasharray: 10;
      animation: dash 5s linear forwards infinite;
    }
    @keyframes dash {
      to {
        stroke-dashoffset: -100;
      }
    }
  }
</style>
